import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { CurrentUser } from '../services/current-user.service';
import { MENIES } from '../../../app-module/menu-nav-bar/menies.constant';
import { MenuNode } from '../../../app-module/menu-nav-bar/menu-nav-bar.model';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private currentUser: CurrentUser, private router: Router) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!this.currentUser.hiddenMenuItems.length) {
      return true;
    }

    const menuNode: MenuNode = this.findMenuNode(route.data['menuLinkInfoKey']);
    if (this.currentUser.hiddenMenuItems.find(x => x === menuNode.id)) {
      this.router.navigate(['/PageNotFound']); // It will use wildcard (**)  NotFoundComponent page (see app.routes.ts)
      return false;
    } else {
      return true;
    }
  }

  private findMenuNode(key: string) {
    if (!key) {
      throw new RangeError('Every menu has to have a key! (data -> menuLinkInfoKey in xx.route.ts)');
    }

    let menu;
    for (let i = 0; i < MENIES.length; i++) {
      if (MENIES[i].id === key) {
        menu = MENIES[i];
      } else if (MENIES[i].children && MENIES[i].children.length) {
        menu = MENIES[i].children.find(x => x.id === key);
      }

      if (menu) {
        break;
      }
    }

    if (!menu) {
      throw new RangeError('Cannot find menuLink. Check if you have provided menuLinkInfoKey in xx.routes.ts');
    }
    return menu;
  }
}
